<div class="container-fluid">
    <app-pagetitle title="Stamp Customer Orders" [actionButton]="{
    label: 'Create Stamp Order',
   onClick: navigateStampOrderCreate
  }"></app-pagetitle>

    <app-api-key-banner product="estamp"></app-api-key-banner>

    <div class="page-content-wrapper">
        <app-loader [loading]="loading"></app-loader>
        <div [class.loading-content]="loading">


            <div class="row">
                <div class="col-lg-12">
                    <div class="card">
                        <div class="card-header">
                            <app-filter searchPlaceholder="Order Id, Stamp value & Purpose"
                                (filterChange)="onFilterChange($event)" searchHint="Order Id, Denomination & Purpose">
                            </app-filter>

                            <div *ngIf="hasActiveFilters" class="text-muted small mt-2">
                                <i class="mdi mdi-information-outline me-1"></i>
                                Filters are applied to the orders of the current page.
                            </div>
                        </div>
                        <div class="card-body">
                            <p-table #dt [value]="orders" [lazy]="true" (onLazyLoad)="getStampOrders($event)"
                                [paginator]="true" [rows]="rows" [totalRecords]="totalRecords" [loading]="loading"
                                [rowsPerPageOptions]="[10,20,50]" responsiveLayout="scroll"
                                styleClass="p-datatable-sm fs-6" [showCurrentPageReport]="true"
                                currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries">

                                <ng-template pTemplate="header">
                                    <tr>
                                        <th>Order Id</th>
                                        <th>State</th>
                                        <th>Attached Stamps</th>
                                        <th>Ordered Stamp value</th>
                                        <th>Stamp loss</th>
                                        <th>Qty</th>
                                        <th>Created</th>
                                        <th class="text-center">Action</th>
                                    </tr>
                                </ng-template>

                                <ng-template pTemplate="body" let-document>
                                    <tr>
                                        <td class="fw-bold">{{ document.orderId }}</td>
                                        <td>{{ document.stateName || '-'}}</td>
                                        <td>₹{{ document.totalStampValue }}</td>
                                        <td>₹{{ document.denomination }}</td>
                                        <td>₹{{ document.stampLoss }}</td>
                                        <td>{{ document.stampIds?.length || 0 }}</td>
                                        <td>{{ document.createdAt | date:'dd/MM/yyyy hh:mm a' }}</td>

                                        <td class="text-center">
                                            <button class="btn btn-sm btn-light" (click)="viewOrder(document)"
                                                ngbTooltip="Detail">
                                                <i class="mdi mdi-eye-outline"></i>
                                            </button>
                                        </td>
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="emptymessage">
                                    <tr>
                                        <td colspan="8" class="text-center py-4 text-muted">
                                            <i class="mdi mdi-database-off-outline me-2"></i>
                                            No document found
                                        </td>
                                    </tr>
                                </ng-template>
                            </p-table>
                        </div>
                    </div>
                </div>
            </div>

        </div>

        @if(showModal){
        <div class="modal fade show d-block">
            <div class="modal-dialog">
                <div class="modal-content">

                    <!-- Header -->
                    <div class="modal-header">
                        <div class="fw-bold">
                            <b>{{ orderDetail.orderId }}</b>
                        </div>

                        <button class="btn-close" (click)="closeModal()"></button>
                    </div>

                    <!-- Body -->
                    <div class="modal-body">

                        <div class="row mb-3">

                            <!-- Client Email -->
                            <div class="col-6 mb-3">
                                <div class="fw-semibold">Client Email</div>
                                <div>{{ orderDetail.clientEmail }}</div>
                            </div>

                            <div class="col-6 mb-3">
                                <div class="fw-semibold">State</div>
                                <td>{{ orderDetail?.stateName || '-'}}</td>
                            </div>
                            <!-- Denomination -->
                            <div class="col-6 mb-3">
                                <div class="fw-semibold">Denomination</div>
                                <div>₹ {{ orderDetail.denomination }}</div>
                            </div>
                            <!-- Stamps -->
                            <div class="col-6 mb-3">
                                <div class="fw-semibold">Stamps</div>
                                <div>{{ orderDetail.stampIds?.length || 0 }}</div>
                            </div>

                            <!-- Total Stamp Value -->
                            <div class="col-6 mb-3">
                                <div class="fw-semibold">Total Stamp Value</div>
                                <div>₹ {{ orderDetail.totalStampValue }}</div>
                            </div>

                            <!-- Stamp Loss -->
                            <div class="col-6 mb-3">
                                <div class="fw-semibold">Stamp Loss</div>
                                <div>₹ {{ orderDetail.stampLoss }}</div>
                            </div>

                            <!-- First Party -->
                            <div class="col-6 mb-3">
                                <div class="fw-semibold">First Party</div>
                                <div>{{ orderDetail.party?.[0]?.firstParty }}</div>
                            </div>

                            <!-- Second Party -->
                            <div class="col-6 mb-3">
                                <div class="fw-semibold">Second Party</div>
                                <div>{{ orderDetail.party?.[1]?.secondParty }}</div>
                            </div>

                            <!-- Append Stamp Position -->
                            <div class="col-6 mb-3">
                                <div class="fw-semibold">Append Stamp Position</div>
                                <div>{{ orderDetail.appendStampPosition }}</div>
                            </div>

                            <!-- Purpose -->
                            <div class="col-12 mb-3">
                                <div class="fw-semibold">Purpose</div>
                                <div>{{ orderDetail.purpose }}</div>
                            </div>

                            <!-- Updated Date -->
                            <div class="col-6 mb-3">
                                <div class="fw-semibold">Updated At</div>
                                <div>{{ orderDetail.updatedAt | date:'medium' }}</div>
                            </div>

                            <!-- Created Date -->
                            <div class="col-6 mb-3">
                                <div class="fw-semibold">Created At</div>
                                <div>{{ orderDetail.createdAt | date:'medium' }}</div>
                            </div>

                            <!-- File Preview Button -->
                            <div class="col-6 mb-3" *ngIf="orderDetail?.fileUrl">

                                <div class="fw-semibold mb-2">Document</div>

                                <a [href]="orderDetail.fileUrl" target="_blank" class="btn btn-outline-primary btn-sm">

                                    Preview Document
                                </a>

                            </div>

                            <!-- Merged File Preview Button -->
                            <div class="col-6 mb-3" *ngIf="orderDetail?.mergedFileUrl">

                                <div class="fw-semibold mb-2">Merged Document</div>

                                <a [href]="orderDetail.mergedFileUrl" target="_blank"
                                    class="btn btn-outline-primary btn-sm">

                                    Preview Merged
                                </a>

                            </div>

                            <div class="col-6 mb-3" *ngIf="orderDetail?.invoice">

                                <div class="fw-semibold mb-2">Amount</div>

                                <div>₹ {{ orderDetail?.invoice?.amount }}</div>

                            </div>

                            <!-- Status -->
                            <div class="col-6 mb-3" *ngIf="orderDetail?.status">
                                <div class="fw-semibold">Status</div>
                                <div>{{ orderDetail.status }}</div>
                            </div>

                        </div>

                    </div>
                </div>
            </div>
        </div>

        }

        @if(showModal){
        <div class="modal-backdrop fade show"></div>
        }

    </div>